export class MstCompliance {
    ComplianceId!: number;
    ComplianceName!: string;
    FromDate ? : number;
    ToDate ? :number;
    CreatedBy ? : string;
    CreatedDate ? : Date;
    UpdateBy ? : string;
    UpdateDate ? :Date;
    IsActive!: boolean;
}
